function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 13,
  y: 13,
  width: 94,
  height: 94,
  fill: "white"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.02944 7.02944C0 14.0589 0 25.3726 0 48V72C0 94.6274 0 105.941 7.02944 112.971C14.0589 120 25.3726 120 48 120H72C94.6274 120 105.941 120 112.971 112.971C120 105.941 120 94.6274 120 72V48C120 25.3726 120 14.0589 112.971 7.02944C105.941 0 94.6274 0 72 0H48C25.3726 0 14.0589 0 7.02944 7.02944ZM94.7974 34.5606C86.2009 26.8583 75.1046 22.6197 63.551 22.6197C47.801 22.6197 33.1984 30.4629 24.4823 43.5941C23.384 45.2558 23.8345 47.4876 25.4962 48.5931C26.1089 48.9945 26.7986 49.1916 27.4887 49.1916C28.6506 49.1916 29.798 48.6282 30.4952 47.5792C37.8666 36.4619 50.2231 29.8296 63.5513 29.8296C73.3239 29.8296 82.7159 33.4132 89.9961 39.9259C91.4676 41.2568 93.7487 41.1368 95.0796 39.6444C96.4098 38.1655 96.283 35.8843 94.7974 34.5606ZM31.1084 69.4827C31.1084 51.5925 45.6613 37.0392 63.5519 37.0392C81.4421 37.0392 95.9953 51.5921 95.9957 69.4827C95.9957 72.2215 95.6506 74.9531 94.9747 77.5864C94.482 79.5158 92.4965 80.6774 90.5884 80.1846C88.659 79.6919 87.4975 77.7206 87.9902 75.7983C88.5181 73.7422 88.7858 71.6162 88.7858 69.4827C88.7858 55.5702 77.4644 44.2488 63.5519 44.2488C49.6394 44.2488 38.318 55.5702 38.318 69.4827C38.318 76.8261 40.5147 83.916 44.3379 88.9221C45.5488 90.506 45.2463 92.7663 43.662 93.9772C43.0074 94.4773 42.2399 94.7166 41.4724 94.7166C40.3883 94.7166 39.318 94.2306 38.6069 93.3012C33.7698 86.9717 31.1084 78.5087 31.1084 69.4827ZM63.5514 51.4582C53.6098 51.4582 45.5274 59.541 45.5274 69.4822C45.5274 84.1338 55.8278 91.3504 61.9674 94.3498C62.4814 94.5961 63.0164 94.7158 63.5517 94.7158C64.8826 94.7158 66.1638 93.9696 66.7903 92.6952C67.6633 90.9067 66.9241 88.7452 65.1357 87.8722C59.4821 85.1122 52.7369 79.6769 52.7369 69.4819C52.7369 63.5183 57.5879 58.6674 63.5514 58.6674C69.5149 58.6674 74.3659 63.5183 74.3659 69.4819C74.3659 71.4744 75.9782 73.0868 77.9708 73.0868C79.9634 73.0868 81.5757 71.4744 81.5757 69.4819C81.5754 59.541 73.4926 51.4582 63.5514 51.4582ZM77.9707 80.2971C72.0071 80.2971 67.1562 75.4461 67.1562 69.4826C67.1562 67.4901 65.5438 65.8777 63.5512 65.8777C61.5587 65.8777 59.9463 67.4901 59.9463 69.4826C59.9466 79.4239 68.0294 87.5067 77.9707 87.5067C79.9632 87.5067 81.5756 85.8943 81.5756 83.9017C81.5756 81.9095 79.9632 80.2971 77.9707 80.2971Z",
  fill: "url(#paint110_linear)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint110_linear",
  x1: 60,
  y1: 0,
  x2: 60,
  y2: 120,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#735EF2"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#5E2AF1"
})));

var SvgDataBankActive = function SvgDataBankActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDataBankActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dataBankActive.e26b48e2.svg";
export { ForwardRef as ReactComponent };